import type { ReactElement } from "react";
import { Text } from "@olivahealth/oli-ui";
import useTranslation from "../../../../hooks/useTranslation";

interface Props {
  isLogin: boolean;
}

export default function PrivacyNotice({ isLogin }: Props): ReactElement {
  const { t, Trans } = useTranslation("auth", { keyPrefix: "privacyNotice" });

  return (
    <Text color="light" size="sm" align="center">
      <Trans
        i18nKey={t("message")}
        values={{ method: isLogin ? t("login") : t("signup") }}
        components={[
          <a
            key="privacyLink"
            className="cursor-pointer text-purple-200"
            href="https://legal.oliva.health/privacy-notice"
            target="_blank"
            rel="noopener noreferrer"
          />,
          <a
            key="termsLink"
            className="cursor-pointer text-purple-200"
            target="_blank"
            rel="noopener noreferrer"
            href="https://olivahouse.notion.site/User-Terms-of-Use-39ea18563bf980c9ac23d28e9133d90c?source=copy_link"
          />,
        ]}
      />
    </Text>
  );
}
